import script from "./HeaderSUUQ.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSUUQ.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSUUQ.vue?vue&type=style&index=0&id=5b743b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b743b8c"]])

export default __exports__